import { TransactionCategory } from "@cosine/stores/useTransactionStore.types";

export default function formatCategory (category: TransactionCategory): string {
  return String(category.match(/\[([^[]+)\]$/)?.at(1));
}
